import React from 'react';
import { Tag, Tooltip } from 'antd';
import styles from 'pages/admin/suppliers/styles.module.scss';
import { TagDotIcon } from 'components/common/icons';

interface ISupplierStatus {
  status: 'ACTIVE' | 'INACTIVE' | 'BLACKLISTED';
  tooltip?: string;
}

export const SupplierStatus = React.memo((props: ISupplierStatus) => {
  const { status, tooltip } = props;
  switch (status) {
    case 'ACTIVE':
      return (
        <Tag
          className={styles.supplier_tag}
          icon={<TagDotIcon color={'#1FC16B'} />}
          bordered={false}
          style={{ backgroundColor: '#E0FAEC', color: '#1FC16B' }}
        >
          Active
        </Tag>
      );
    case 'INACTIVE':
      return (
        <Tooltip title={tooltip}>
          <Tag
            className={styles.supplier_tag}
            icon={<TagDotIcon color={'#525866'} />}
            bordered={false}
            style={{ backgroundColor: '#E1E4EA', color: '#525866' }}
          >
            Inactive
          </Tag>
        </Tooltip>
      );
    case 'BLACKLISTED':
      return (
        <Tooltip title={tooltip}>
          <Tag
            className={styles.supplier_tag}
            icon={<TagDotIcon color={'#FB3748'} />}
            bordered={false}
            style={{ backgroundColor: '#FFEBEC', color: '#FB3748' }}
          >
            Blacklisted
          </Tag>
        </Tooltip>
      );
    default:
      return null;
  }
});
